function initStickyNav() {
  let didScroll;
  let lastScrollTop = 0;
  const navbarHeight = $('.mega-menu').outerHeight();

  $(window).scroll(function() {
    didScroll = true;
  });

  if (!($('.page-wrap').height() < $(window).height())) {
    setInterval(function() {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);
  }

  function hasScrolled() {
    const st = $(window).scrollTop();

    if (st > lastScrollTop && st > navbarHeight - 70) {
      $('.page-wrap').removeClass('up').addClass('hide');
      $('.top-menu').removeClass('top-menu-scrollup').addClass('top-menu-up');
      $('.mega-menu').removeClass('mega-menu-scrollup').addClass('mega-menu-up');
      $('.overlay').removeClass('scrollup').addClass('fixed-top');
    } else if (st + $(window).height() < $(document).height()) {
      $('.page-wrap').removeClass('hide').addClass('up');
      $('.top-menu').removeClass('top-menu-up').addClass('top-menu-scrollup');
      $('.mega-menu').removeClass('mega-menu-up').addClass('mega-menu-scrollup');
      $('.overlay').removeClass('fixed-top').addClass('scrollup');
      if (st === 0) {
        $('.mega-menu').removeClass('mega-menu-scrollup');
        $('.top-menu').removeClass('top-menu-scrollup');
        $('.page-wrap').removeClass('up hide');
        $('.overlay').removeClass('scrollup fixed-top');
      }
    }

    lastScrollTop = st;
  }
}

export default { initStickyNav };



// WEBPACK FOOTER //
// ./src/js/custom/sticky-nav.js